import sortByItem from './sort-by-item';

export default sortByItem('label');
